import { render, staticRenderFns } from "./ecgChart.vue?vue&type=template&id=1b084584&lang=pug"
import script from "./ecgChart.vue?vue&type=script&lang=js"
export * from "./ecgChart.vue?vue&type=script&lang=js"
import style0 from "./ecgChart.vue?vue&type=style&index=0&id=1b084584&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports